import { render, staticRenderFns } from "./requestsWithDraw.vue?vue&type=template&id=45171587&"
import script from "./requestsWithDraw.vue?vue&type=script&lang=js&"
export * from "./requestsWithDraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports